<div class="pt-4">
  <h5 class="mb-3">Change password</h5>
  <form [formGroup]="userEditPasswordForm" (ngSubmit)="onSubmit()">
    <div class="flex flex-wrap">
      <div class="form-group mr-2">
        <label>New password</label>
        <input formControlName="password" type="password" class="form-control" placeholder="New password..."/>
        <div
          class="mt-3"
          *ngIf="userEditPasswordForm.controls.password.dirty && userEditPasswordForm.controls.password.errors !== null"
        >
          <div class="text-red mt-2" role="alert">Incorrect password</div>
        </div>
      </div>
      <div class="form-group">
        <label>Repeat new password</label>
        <input formControlName="retyped_password" type="password" class="form-control" placeholder="New password..."/>
        <div class="mt-3" *ngIf="userEditPasswordForm.controls.retyped_password.dirty && userEditPasswordForm.controls.password.dirty && userEditPasswordForm.errors !== null && userEditPasswordForm.errors.matchFields">
          <div class="text-red" role="alert">Passwords do not match. Please try again</div>
        </div>
      </div>
    </div>
    <div>
      <button type="submit" class="btn btn-blue btn-blue-hover px-4 my-3">Save changes</button>
    </div>
  </form>
</div>
